import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceContentsSetting',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,
      
      // テーブルオプション
      tableColumns: [
        'serviceContentsId',
        'contentsName',
        'serviceType',
        'deviceType',
        'modifyButton',
        'screenButton',
        'snapshotButton',
        'deleteButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          serviceContentsId: 'コンテンツID',
          contentsName: 'コンテンツ名',
          serviceType: 'サービスタイプ',
          deviceType: '対象デバイス',
          modifyButton: '',
          screenButton: '',
          snapshotButton: '',
          deleteButton: ''
        },
        columnsClasses: {
          serviceContentsId: 'wp-5',
          contentsName: '',
          serviceType: '',
          deviceType: '',
          modifyButton: 'wp-5 has-button',
          screenButton: 'wp-5 has-button',
          snapshotButton: 'wp-5 has-button',
          deleteButton: 'wp-5 has-button'
        },
        sortable: [
          'serviceContentsId',
          'contentsName',
          'serviceType',
          'deviceType'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      deleteTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceContentsSetting.categoryName,
      serviceName: state => state.serviceContentsSetting.serviceName,

      // model
      contentsSettingModel: state => state.serviceContentsSetting.contentsSettingModel,
      updatedList: state => state.serviceContentsCopyModal.updated,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 削除
      if (this.confirmKey === 'delete') {
        if (to) this.deleteData()
      }
    },
    updatedList: function (to) {
      if (!to) return
      // モーダルで適用コンテンツの変更がされたら一覧を更新
      this.init()
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceContentsSetting/loadModel',
      showServiceContentsCopyModal: 'serviceContentsCopyModal/show',
      showServiceContentsRegistSnapshotModal: 'serviceContentsRegistSnapshotModal/show'
    }),

    init () {
      this.loading = true

      //
      let contentsSettingParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        contentsSettingParams: contentsSettingParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.contentsSettingModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      // switch (key) {
      //   case 'attributeTypeStatus':
      //     return Utility.getConstantsLabel(['Status'], value)
      // }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    showContentsSelector () {
      this.showServiceContentsCopyModal({
        serviceId: this.serviceId,
      })
    },

    modifyItem (props) {
      this.$router.push({
        name: 'ServiceContentsSettingForm',
        params: {
          serviceId: this.serviceId,
          serviceContentsId: String(props.row.serviceContentsUuid)
        }
      })
    },
    screenItem (props) {
      this.$router.push({
        name: 'ServiceScreenSetting',
        params: {
          serviceId: this.serviceId,
          serviceContentsId: String(props.row.serviceContentsUuid)
        }
      })
    },
    snapshotItem (props) {
      // console.log(props)
      this.showServiceContentsRegistSnapshotModal({
        serviceId: this.serviceId,
        serviceContentsId: props.row.serviceContentsUuid
      })
    },
    deleteItem (props) {
      this.deleteTargetId = props.row.serviceContentsUuid

      // confirm
      const id = Utility.getObjectArrayValue(this.contentsSettingModel, 'serviceContentsUuid', this.deleteTargetId, 'serviceContentsId')
      this.showConfirm({
        key: 'delete',
        title: '',
        body: '「Id : ' + id + '」の' + this.categoryName + 'を削除しますか？',
        acceptLabel: '削除'
      })
    },

    /**
     * データの削除
     */
    deleteData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        serviceContentsUuid: this.deleteTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceContentsSetting'],
        ['v1ServiceContentsSettingDelete'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + '情報の削除',
              body: this.categoryName + 'を削除しました。'
            })

            this.deleteTargetId = null

            // 一覧データを再読出し
            this.init()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
  }
}